import { IconPencil } from "@tabler/icons-react"
import { type FC, useEffect, useState } from "react"

import Form from "@forento/ui/components/Form"

import Button, { SecondaryButton } from "~/components/button"
import { Input } from "~/components/input"
import { query } from "~/utilities/trpc"

type Props = { course: { id: string; shortDescription: string }; reload(): Promise<unknown> }
const ShortDescription: FC<Props> = ({ course, reload }) => {
	const [isEditing, setEditing] = useState(false)
	const [shortDescription, setShortDescription] = useState(course.shortDescription)

	useEffect(() => {
		setShortDescription(course.shortDescription)
	}, [course.shortDescription])

	const updateCourse = query.updateCourse.useMutation({
		async onSuccess() {
			await reload()
			setEditing(false)
		},
		onError(error) {
			console.error(error)
		},
	})

	return (
		<div className="mb-4">
			<div className="mb-2 flex items-center gap-2">
				<h2 className="font-semibold text-slate-800">📝 Kort beskrivning</h2>
				{!isEditing && (
					<button
						type="button"
						className="text-primary hover:text-primary/80 cursor-pointer"
						onClick={() => setEditing(true)}
					>
						<IconPencil className="size-4" />
					</button>
				)}
			</div>
			{!isEditing ? (
				<div className="flex items-start justify-between">
					<p className="text-base leading-relaxed text-slate-700">{course.shortDescription}</p>
				</div>
			) : (
				<Form
					onSubmit={() => updateCourse.mutate({ id: course.id, shortDescription })}
					className="flex flex-col gap-4"
				>
					<Input
						type="text"
						value={shortDescription}
						onChange={setShortDescription}
						placeholder="Ange kort beskrivning"
						autoFocus
						required
						className="flex-1"
					/>
					<div className="flex gap-4">
						<Button type="submit" color="green" disabled={updateCourse.isPending}>
							{updateCourse.isPending ? "Sparar..." : "Spara"}
						</Button>
						<SecondaryButton onClick={() => setEditing(false)}>Avbryt</SecondaryButton>
					</div>
				</Form>
			)}
		</div>
	)
}

export default ShortDescription
